import React from 'react';
import TextIcon from "../TextIcon";
import PropTypes from 'prop-types'

const ActionTextButton = ({className, onClick, icon, text}) => {
  return (
    <TextIcon
      className={`cursor-pointer hover-change small small-radius s-px-4px ${className}`}
      onClick={onClick}
      icon={icon}
      text={text}/>
  );
};

ActionTextButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
}

export default ActionTextButton;
